import React from 'react';
import { revertAvatarSwitch } from '../../services/avatarSwitch';

/**
 * Error boundary around the local player's avatar (desktop body and VR body).
 * If an avatar just switched to throws while rendering, the previous avatar is
 * put back (and a toast explains). Key it by the avatar URL so a reverted or
 * newly chosen avatar gets a fresh boundary.
 */
export class AvatarSwitchGuard extends React.Component<{ url: string; fallback?: React.ReactNode; children: React.ReactNode }, { failed: boolean }> {
  state = { failed: false };
  static getDerivedStateFromError() { return { failed: true }; }
  componentDidCatch(error: Error) { revertAvatarSwitch(this.props.url, error); }
  render() { return this.state.failed ? (this.props.fallback ?? null) : this.props.children; }
}
